import axios from 'axios';

export default axios.create({
  baseURL: 'http://evantage.ddns.net/cmms_kpj_dev',
  // baseURL: 'http://192.168.0.34:8080/cmms_kpj_dev/',
  // baseURL: 'http://localhost:8080/cmms_kpj_dev',
  headers: {
    'Content-type': 'application/json',
  },
});
